import {shareManagerConstants} from "../redux_constants/shareManager.constant";


export const changeSlideShareModalOpenState = () => ({
    type: shareManagerConstants.CHANGE_SLIDE_MODAL_OPEN_STATE,
})

export const changeCaseShareModalOpenState = () => ({
    type: shareManagerConstants.CHANGE_CASE_MODAL_OPEN_STATE,
})

/**
 * @param {Array/ID} slides - Array of slide ids or single slide id
*/
export const addSlidesToShare = (slides) => ({
    type: shareManagerConstants.ADD_SLIDES_TO_SHARE,
    slides
})

/**
 * @param {Array/ID} cases - Array of case ids or single case id
 */
export const addCasesToShare = (cases) => ({
    type: shareManagerConstants.ADD_CASES_TO_SHARE,
    cases
})

export const changeLinkExpiration = (link_expiration) => ({
    type: shareManagerConstants.CHANGE_LINK_EXPIRATION,
    link_expiration
})

export const removeLinkExpiration = () => ({
    type: shareManagerConstants.REMOVE_LINK_EXPIRATION
})